module.exports = __webpack_public_path__ + "media/images/iconPlus__accent--dark-e918985ceffc829ebf3e528d3793fb52.png";